<template>
    <div class="flex items-center justify-center">
        <select v-model="selectedLanguage" @change="changeLanguage"
            class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            :class="transparent ? 'border-0 bg-transparent' : 'border-0 bg-white shadow'">
            <option v-for="language in languages" :key="language.code" :value="language.code">
                {{ language.name }}
            </option>
        </select>
    </div>
</template>

<script>
import UsuarioService from "@/services/usuario.service";
import { useToast } from "vue-toastification";

export default {
    props: {
        transparent: {}
    },
    data() {
        return {
            selectedLanguage: this.$i18n.locale,
            languages: [
                { code: 'en', name: 'English' },
                { code: 'es', name: 'Español' }
            ]
        };
    },
    methods: {
        changeLanguage() {
            const toast = useToast();
            this.$i18n.locale = this.selectedLanguage;
            const languages = {
                en: 'English',
                es: 'Español'
            };
            const currentLanguage = languages[this.selectedLanguage];
            UsuarioService.updateLanguage({ idioma: currentLanguage })
                .then(() => {
                    toast.success(this.$t('languageChanged'));
                })
                .catch((error) => {
                    console.error(error);
                    toast.error(error);
                });
        }
    }
};
</script>